const elementIsInView = (element, allowPartial = false) => {
  const rect = element.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;

  if (allowPartial) {
    return elemTop < window.innerHeight && elemBottom >= 0;
  }

  return elemTop >= 0 && elemBottom <= window.innerHeight;
};

export default elementIsInView;
